import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const KeyPointMiniMap = ({ lat, lon, km, routeCoordinates, pointRadius = 2 }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    // Crear mini mapa
    const map = L.map(mapRef.current, {
      center: [lat, lon],
      zoom: 14,
      zoomControl: false,
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      boxZoom: false,
      keyboard: false,
      attributionControl: false
    });

    // Tiles OpenStreetMap
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 16
    }).addTo(map);

    // Dibuixar traçat de la ruta (si disponible)
    if (routeCoordinates && routeCoordinates.length > 0) {
      // Trobar segment proper al punt
      const pointIndex = Math.round((km / routeCoordinates[routeCoordinates.length - 1].distance) * routeCoordinates.length);
      const startIndex = Math.max(0, pointIndex - 50);
      const endIndex = Math.min(routeCoordinates.length, pointIndex + 50);
      
      const segmentCoords = routeCoordinates.slice(startIndex, endIndex).map(c => [c.lat, c.lon]);
      
      // Ruta completa (gris clar)
      L.polyline(routeCoordinates.map(c => [c.lat, c.lon]), {
        color: '#cbd5e1',
        weight: 3,
        opacity: 0.5
      }).addTo(map);

      // Segment proper (blau destacat)
      L.polyline(segmentCoords, {
        color: '#667eea',
        weight: 4,
        opacity: 0.9
      }).addTo(map);
    }

    // Marcador del punt exacte
    const marker = L.circleMarker([lat, lon], {
      radius: 8,
      fillColor: '#ef4444',
      color: '#ffffff',
      weight: 2,
      opacity: 1,
      fillOpacity: 0.9
    }).addTo(map);

    // Àrea d'influència (cercle gran)
    L.circle([lat, lon], {
      radius: pointRadius * 1000, // convertir km a metres
      fillColor: '#ef4444',
      color: '#ef4444',
      weight: 1,
      opacity: 0.3,
      fillOpacity: 0.1
    }).addTo(map);

    mapInstanceRef.current = map;

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, [lat, lon, km, routeCoordinates, pointRadius]);

  return (
    <div 
      ref={mapRef} 
      style={{ 
        height: '180px', 
        width: '100%', 
        borderRadius: '8px', 
        border: '2px solid #e2e8f0',
        marginTop: '10px'
      }} 
    />
  );
};

export default KeyPointMiniMap;